import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Tooltip } from 'antd'
import 'react-datasheet/lib/react-datasheet.css'
import styled from 'styled-components'
import { TinyArea, TinyColumn } from '@ant-design/charts'
import { BLOCK_ICON, DOT3_ICON } from 'Assets'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useDashboardMain } from 'Hooks/dashboardMain'
import TabDashboard from './tab'
import TopSearchDashboard from './topSearch'
import SaleDashboard from './sale'

const DashBoardStyled = styled.div`
  .ant-card-head-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.85);
  }
  .flex-center{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
  }
  .text-size-24 {
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    color: rgba(0, 0, 0, 0.85);

    margin-right: 32px;
  }
  .text-size-14 {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.45);

    margin-right: 9px;
  }
  .text-size-16 {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.85);

    margin-right: 9px;
  }
`

export const CardContent = styled(Card)`
  height: 182px;
  .ant-card-body {
    padding: 20px 24px 14px;
    height: 100%;
  }
`

export const TitleCard = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.45);

  margin-bottom: 5px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const BodyCard = styled.div`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: rgba(0, 0, 0, 0.85);

  min-width: 232px;
  width: auto;
  @media screen and (min-width: 1200px) and (max-width: 1439px) {
    font-size: 16px;
    min-width: 0;
  }

  &.size-large {
    font-size: 30px;
    line-height: 40px;
    @media screen and (min-width: 1200px) and (max-width: 1439px) {
      font-size: 20px;
      line-height: 32px;
    }
  }

  .content-body-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`

export const ChartCard = styled.div`
  height: 44px;
`

export const FooterCard = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
  @media screen and (min-width: 1200px) and (max-width: 1439px) {
    font-size: 13px;
  }

  margin-top: 10px;
`

export default function DashBoard() {
  const Kilo = 1000
  const Million = 1000000
  const Billion = 1000000000
  const [trans] = useTranslation(['dashboard', 'common'])
  const { dataDashboard } = useDashboardMain()
  const [dataMonthlyPayment, setDataMonthlyPayment] = useState({})
  const [dataMOM, setDataMOM] = useState({})
  const [dataActivity, setDataActivity] = useState({
    mau: '',
    dau: ''
  })
  const [dataChartActivity, setDataChartActivity] = useState([])
  const [dataChartVisit, setDataChartVisit] = useState([])

  const [dataVisit, setDataVisit] = useState({})
  const getConfigArea = (dataArea, color, rest) => ({
    height: 44,
    autoFit: true,
    data: dataArea,
    smooth: true,
    line: {
      color: '#975FE4'
    },
    areaStyle: {
      fill: color || '#975FE4',
      ...rest
    }
  })

  const getConfigLine = (dataLine) => ({
    height: 44,
    autoFit: true,
    data: dataLine,
    columnStyle: {
      fill: '#58AFFF'
    }
  })

  const convertMoney = (money) => {
    if (money) {
      if (money > 100000000) {
        return `${(money / Billion).toFixed(2)} B`
      } if (money > 100000) {
        return `${(money / Million).toFixed(2)} M`
      } if (money > 100) {
        return `${(money / Kilo).toFixed(2)} K`
      }
      return money
    }
    return ''
  }

  useEffect(() => {
    if (dataDashboard) {
      setDataMonthlyPayment(dataDashboard.summary?.payment)
      setDataMOM(dataDashboard.summary?.mom)
      if (dataDashboard.summary?.userActivity) {
        const dataSummaryActivity = dataDashboard.summary?.userActivity
        const valueActivity = {
          mau: dataSummaryActivity?.month?.monthlyRegistedUser
            ? `${((dataSummaryActivity?.month?.monthlyActivity * 100) / dataSummaryActivity?.month?.monthlyRegistedUser).toFixed(2)} %`
            : '---',
          dau: dataSummaryActivity?.month?.monthlyRegistedUser
            ? `${((dataSummaryActivity?.date?.dailyActitivy * 100) / dataSummaryActivity?.month?.monthlyRegistedUser).toFixed(2)} %`
            : '---'
        }
        setDataActivity(valueActivity)
        const chart = dataSummaryActivity?.month?.chart
        if (chart && chart.length > 0) {
          const arrDataChartActivity = []
          for (let i = 0; i < chart.length; i += 1) {
            const dataItem = chart[i]?.count_register
              ? ((chart[i]?.count_activity * 100) / chart[i]?.count_register).toFixed(2)
              : 0
            arrDataChartActivity.push(dataItem)
          }
          setDataChartActivity(arrDataChartActivity)
        }
      }
      if (dataDashboard.summary?.visit) {
        const chart = dataDashboard.summary?.visit?.monthlyChart
        if (chart && chart.length > 0) {
          const arrDataChartActivity = []
          for (let i = 0; i < chart.length; i += 1) {
            arrDataChartActivity.push(chart[i]?.activeUsers)
          }
          setDataChartVisit(arrDataChartActivity)
        }
      }
      setDataVisit(dataDashboard.summary?.visit)
    }
  }, [dataDashboard])

  return (
    <DashBoardStyled>
      <Row gutter={[24, 24]}>
        <Col sm={12} xl={6}>
          <CardContent>
            <TitleCard><span>{trans('dashboard:TotalSale')}</span><Tooltip placement="topLeft" title="Planned amount for this month"><BLOCK_ICON /></Tooltip></TitleCard>
            <BodyCard className="size-large">{dataMOM?.value ? `US$ ${convertMoney(dataMOM?.value)}` : ''}</BodyCard>
            <FooterCard style={{ marginTop: '20px' }}>
              MoM {trans('dashboard:change')} {dataMOM?.rate ? `${(dataMOM?.rate * 100).toFixed(2)}%` : ''}
              <span>
                {
                  dataMOM?.rate > 0 ? <CaretUpOutlined style={{ color: '#52C41A' }} />
                    : <CaretDownOutlined style={{ color: 'red' }} />
                }
              </span>
            </FooterCard>
          </CardContent>
        </Col>
        <Col sm={12} xl={6}>
          <CardContent>
            <TitleCard><span>{trans('dashboard:userActivity')}</span>
              <Tooltip
                placement="topLeft"
                title={(
                  <>
                    <div>MAU = Monthly Active Users</div>
                    <div>DAU = Daily Active Users</div>
                  </>
                )}
              ><BLOCK_ICON />
              </Tooltip>
            </TitleCard>
            <BodyCard>
              <div className="content-body-card"><span>MAU</span>
                <span>{dataActivity?.mau}</span>
              </div>
              <div className="content-body-card"><span>DAU</span>
                <span>{dataActivity?.dau}</span>
              </div>
            </BodyCard>
            <ChartCard><TinyArea {...getConfigArea(dataChartActivity, '#975FE4', { fillOpacity: 1 })} /></ChartCard>
          </CardContent>
        </Col>
        <Col sm={12} xl={6}>
          <CardContent>
            <TitleCard><span>{trans('dashboard:visits')}</span>
              <Tooltip
                placement="topLeft"
                title={(
                  <>
                    <div>Daily PV = The number of visitors view page</div>
                    <div>Bounce Rate = The percentage of single-page sessions in which there was no interaction with the page. A bounced session has a duration of 0 seconds</div>
                  </>
            )}
              >
                <BLOCK_ICON />
              </Tooltip>
            </TitleCard>
            <BodyCard>
              <div className="content-body-card"><span>Daily PV</span>
                <span>{dataVisit?.dailyVisit?.dailyVisit ? `${Intl.NumberFormat('en-US').format(dataVisit?.dailyVisit?.dailyVisit)}` : '0'}</span>
              </div>
              <div className="content-body-card"><span>Bounce Rate</span>
                <span>{dataVisit?.dailyVisit?.bounceRate ? `${(dataVisit?.dailyVisit?.bounceRate * 100).toFixed(2)} %` : '0 %'}</span>
              </div>
            </BodyCard>
            <ChartCard><TinyArea {...getConfigArea(dataChartVisit, '#975FE4', { fillOpacity: 1 })} /></ChartCard>
          </CardContent>
        </Col>
        <Col sm={12} xl={6}>
          <CardContent>
            <TitleCard><span>{trans('dashboard:monthlyPayments')}</span>
              <Tooltip
                placement="topLeft"
                title={(
                  <>
                    <div>Payment amount for this month</div>
                    <div>Conversion Rate = Payment amount for this month / Planned amount for this month</div>
                  </>
        )}
              >
                <BLOCK_ICON />
              </Tooltip>
            </TitleCard>
            <BodyCard>{ dataMonthlyPayment?.month ? `US$  ${convertMoney(dataMonthlyPayment?.month)}` : ''}</BodyCard>
            <ChartCard><TinyColumn {...getConfigLine(dataMonthlyPayment?.monthChart || [])} /></ChartCard>
            <FooterCard>{trans('dashboard:conversionRate')} <span>{dataMonthlyPayment?.conversionRate ? `${dataMonthlyPayment?.conversionRate} %` : ''}</span></FooterCard>
          </CardContent>
        </Col>
      </Row>
      <Row style={{ marginTop: '24px' }}>
        <Col span={24}>
          <TabDashboard />
        </Col>
      </Row>
      <Row gutter={[24, 24]} style={{ marginTop: '24px' }}>
        <Col span={12}>
          <Card
            title={trans('dashboard:onlineTopSearch')}
            extra={<DOT3_ICON />}
          >
            <TopSearchDashboard />
          </Card>
        </Col>
        <Col span={12}>
          <Card
            style={{ textAlign: 'center' }}
            title={trans('dashboard:theProportionOfSales')}
          >
            <SaleDashboard convertMoney={convertMoney} />
          </Card>
        </Col>
      </Row>
    </DashBoardStyled>
  )
}
